import { createStyles, rem } from '@mantine/core'

interface StylesParams {
  layout?: 'vertical' | 'horizon'
  hasPromotion: boolean
}

export default createStyles((theme, { layout, hasPromotion }: StylesParams) => {
  return {
    root: {
      background: '#fff',
      borderRadius: 8,
      padding: 8,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      flex: '1 1 0px',
      ...(layout === 'horizon'
        ? {
            gap: rem(8),
          }
        : {
            gap: rem(4),
          }),
    },
    thumbnail: {
      position: 'relative',
      ...(layout === 'horizon' && {
        width: rem(120),
        flexGrow: 0,
      }),
    },
    info: {
      display: 'flex',
      flexDirection: layout === 'horizon' ? 'row' : 'column',
      gap: 8,
    },
    mainInfo: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      ...(layout === 'horizon' && {
        justifyContent: 'center',
        gap: 4,
        width: `calc(100% - 128px)`,
      }),
    },
    name: {
      ...(layout === 'horizon' &&
        hasPromotion && {
          paddingRight: rem(30),
        }),
    },
    prices: {
      display: 'flex',
      gap: rem(8),
    },
    mainPrice: {
      color: theme.colors.red[8],
    },
    originPrice: {
      textDecoration: 'line-through',
      color: '#737373',
    },
    actions: {
      display: 'flex',
    },
    cartBtn: {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },
    buyBtn: {
      width: `calc(100% - 40px)`,
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
    },
    affBuyBtn: {
      flexGrow: 1,
    },
    discountTag: {
      position: 'absolute',
      right: 0,
      top: 0,
    },
  }
})
